import React, { useEffect, useState } from 'react'
import { RiDeleteBinLine } from 'react-icons/ri'
import PopNotificationModel from './PopNotificationModel';
import { useDispatch } from 'react-redux';
import { deleteNotificationSend, EmailNotificationFetch } from '../../../Redux/Actions/AdminNotificationList';
import { FaSpinner } from 'react-icons/fa';

const PopNotification = () => {
    const [show, setShow] = useState(false);
    const dispatch = useDispatch()
    const [id, setId] = useState('')
    const [fetchData, setFetchData] = useState([])
    const [loader, setLoader] = useState({
        fetch: false,
        save: false,
        delete: false
    })
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const fetchMessage = () => {
        setLoader({
            ...loader,
            fetch: true
        })
        dispatch(EmailNotificationFetch("fetch-popup-notification", setFetchData, setLoader, loader))
    }
    useEffect(() => {
        fetchMessage()
    }, [])
    const handleDelete = (id) => {
        setId(id)
        setLoader({
            ...loader,
            delete: true
        })
        let formData = {
            "id": id
        }
        dispatch(deleteNotificationSend("delete-popup-notification", formData, setLoader, loader, fetchMessage))
    }

    return (
        <div className='account-block pt-3'>
            <div className="table-responsive mt-2">
                <div className='d-flex align-items-center justify-content-between mb-3'>
                    <h6>Pop Notification

                    </h6>
                    <div onClick={handleShow} style={{ width: "fit-content" }} className='theme-btn ms-auto d-flex justify-content-end'>
                        Add Notification</div>
                </div>
                {loader.fetch ? <div className="d-flex align-items-center justify-content-center mt-4"><FaSpinner className="spin ms-1" style={{ fontSize: "40px", height: "100vh" }} /></div> :
                    <table className="table theme-table">
                        <tr>
                            <th>Heading
                            </th>
                            <th>Sub Heading
                            </th>
                            <th>Description
                            </th>
                            <th >Image
                            </th>
                            <th >Expiry Date
                            </th>
                            <th >Action
                            </th>
                        </tr>

                        {fetchData.length > 0 ? fetchData?.map((curElem, i) => {

                            return (
                                < tr>
                                    < td className="position-unset" data-label="Heading">{curElem.heading}
                                    </td>
                                    <td data-label="Sub Heading">{curElem.subheading}</td>
                                    <td data-label="Description" dangerouslySetInnerHTML={{ __html: curElem.description }}></td>
                                    <td data-label="Image">
                                        {curElem.image ? <img src={curElem.image} alt="" style={{ width: "50px", height: "50px" }} /> : "No Image"}
                                    </td>
                                    <td data-label="Expiry Date">
                                        {curElem.expiry_date ? curElem.expiry_date : "No Expiry Date"}
                                    </td>
                                    <td data-label="Action">
                                        <div className="table-btns d-flex align-items-center gap-2">
                                            <span className="table-delete"
                                                onClick={() => handleDelete(curElem.id)}
                                            >
                                                {
                                                    curElem.id === id ? loader.delete ? <FaSpinner className="spin ms-1" /> : null :
                                                        <RiDeleteBinLine />
                                                }
                                            </span>
                                        </div>
                                    </td>
                                </tr>

                            )
                        })
                            : <td className='text-center py-3' colSpan={7}>

                                No message found
                            </td>}

                    </table>
                }
            </div>
            <PopNotificationModel show={show} handleClose={handleClose} loader={loader} setLoader={setLoader} fetchMessage={fetchMessage} />
        </div>
    )
}

export default PopNotification